import React, { useEffect, useState } from "react";
import axios from "axios";
import { API_BASE_URL } from "../config/api";
import { Card, CardBody, CardFooter, CardTitle, Row, Col } from "reactstrap";
import { useProtectedRoute } from './useProtectedRoute';
import { useNavigate } from 'react-router-dom';

const buildWinnerDayKey = (row) => {
  const value = row?.draw_created_at || row?.participation_date;
  if (!value) {
    return "Unknown";
  }

  const date = new Date(value);
  if (Number.isNaN(date.getTime())) {
    return "Unknown";
  }

  return `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, "0")}-${String(date.getDate()).padStart(2, "0")}`;
};

const buildWinnerUserKey = (row) =>
  row?.user_id || row?.player_id || row?.email || row?.PhoneNumber || row?.fullName || row?.id || "unknown";

const getDefaultGameStatsRange = () => {
  const now = new Date();
  const to = now.toISOString().slice(0, 10);
  const fromDate = new Date(now);
  fromDate.setDate(now.getDate() - 29);

  return {
    from: fromDate.toISOString().slice(0, 10),
    to,
  };
};

function Dashboard() {
  // const [gallerycount, setgallery] = useState([]);
  // const [SocialMediacount, setSocialMedia] = useState([]);
  const navigate = useNavigate();
  const [gallerycount, setGallery] = useState([]);
  const [HomePage, setHomePage] = useState([]);
  const [bannerCount, setBannerCount] = useState(0);
  const [about, setabout] = useState([]);
  const [userCount, setUserCount] = useState(0);
  const [TankShop, setTankShop] = useState([]);
  const [PrivacyPolicies, setPrivacyPolicies] = useState([]);
  const [termCount, setTermCount] = useState(0);
  const [isUpdateClicked, setIsUpdateClicked] = useState(false);
  const [eventCount, setEventCount] = useState([]);
  const [adminCount, setAdminCount] = useState([]);
  const [notification, setnotification] = useState([]);
  const [About2, setAbout2] = useState([]);
  const [qr_code, setQr_code] = useState([]);
  const [gameQuestions, setGameQuestions] = useState([]);
  const [introVideos, setIntroVideos] = useState([]);
  const [socialMediaIcons, setSocialMediaIcons] = useState([]);
  const [contacts, setContacts] = useState([]);
  const [locationCount, setLocationCount] = useState(0);
  const [announcements, setAnnouncements] = useState([]);
  const [gameLevels, setGameLevels] = useState([]);
  const [gameWinners, setGameWinners] = useState([]);
  const [gameStatsTotals, setGameStatsTotals] = useState({ total_winners: 0, total_participants: 0 });
  const userRole = 'admin'; // Fetch the user's role or use the state you've stored

  // Protect this route for 'admin' and 'superadmin' roles
  useProtectedRoute(['admin', 'superadmin'], userRole);

  const cardStyle = { cursor: 'pointer', minHeight: '150px' };
  const gameDrawsWinnersCount = new Set(
    gameWinners.map((winner) => `${buildWinnerDayKey(winner)}::${buildWinnerUserKey(winner)}`)
  ).size;

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.get(
          `${API_BASE_URL}/event/list`
        );
        // setProduct(response.data);
        console.log(`rrr${response}`)
        setEventCount(response.data.data);
      } catch (error) {
        console.log(`Error getting news from frontend: ${error}`);
      }
    };

    fetchData();
  }, []);

  // useEffect(() => {
  //   const fetchData = async () => {
  //     try {
  //       const response = await axios.get(
  //         `${API_BASE_URL}/gallery/images`
  //       );
  //       setgallery(response.data.data);
  //     } catch (error) {
  //       console.log(`Error getting Blog from frontend: ${error}`);
  //     }
  //   };

  //   fetchData();
  // }, []);
  // useEffect(() => {
  //   const fetchData = async () => {
  //     try {
  //       const response = await axios.get(
  //         `${API_BASE_URL}/social_media/list`
  //       );
  //       setSocialMedia(response.data.data);
  //     } catch (error) {
  //       console.log(`Error getting Blog from frontend: ${error}`);
  //     }
  //   };

  //   fetchData();
  // }, []);
  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.get(
          `${API_BASE_URL}/gallery/images`
          
        );
        setGallery(response.data.data);
      } catch (error) {
        console.log(`Error getting Blog from frontend: ${error}`);
      }
    };

    fetchData();
  }, []);
  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.get(
          `${API_BASE_URL}/background/list`
        );
        setHomePage(response.data.data);
      } catch (error) {
        console.log(`Error getting Blog from frontend: ${error}`);
      }
    };

    fetchData();
  }, []);
  useEffect(() => {
    const fetchBannerCount = async () => {
      try {
        const response = await axios.get(
          `${API_BASE_URL}/icons/list`
        );
        const list = Array.isArray(response.data?.data) ? response.data.data : [];
        setBannerCount(list.length);
      } catch (error) {
        console.log(`Error getting banners from frontend: ${error}`);
      }
    };

    fetchBannerCount();
  }, []);
  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.get(
          `${API_BASE_URL}/about/list2`
          // "https://seashell-app-6v6yj.ondigitalocean.app/about/list"
        );
        setabout(response.data.data);
        console.log(`aaa${response}`)
      } catch (error) {
        console.log(`Error getting Blog from frontend: ${error}`);
      }
    };

    fetchData();
  }, []);
  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.get(
          `${API_BASE_URL}/user/count`
        );
        const userCount = response.data.data[0].count; // Access the count property inside data
        setUserCount(userCount);
      } catch (error) {
        console.log(`Error getting Blog from frontend: ${error}`);
      }
    };

    fetchData();
  }, []);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.get(
          `${API_BASE_URL}/shop/list`
        );
        setTankShop(response.data.data);
      } catch (error) {
        console.log(`Error getting Blog from frontend: ${error}`);
      }
    };

    fetchData();
  }, []);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.get(
          `${API_BASE_URL}/privacy/list`
        );
        setPrivacyPolicies(response.data.data);
      } catch (error) {
        console.log(`Error getting Blog from frontend: ${error}`);
      }
    };

    fetchData();
  }, []);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.get(`${API_BASE_URL}/terms/list`);
        if (response.data && Array.isArray(response.data.data)) {
          setTermCount(response.data.data.length); // Correctly set the count of terms
        } else {
          console.error("Unexpected response format:", response.data);
          // Handle this situation appropriately
        }
      } catch (error) {
        console.error(`Error getting terms from frontend: ${error}`);
      }
    };
  
    fetchData();
  }, []);
  
  
  

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.get(
          `${API_BASE_URL}/admin/list`
        );
        setAdminCount(response.data.data);
      } catch (error) {
        console.log(`Error getting Blog from frontend: ${error}`);
      }
    };

    fetchData();
  }, []);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.get(
          `${API_BASE_URL}/notification/list`
        );
        setnotification(response.data.data);
      } catch (error) {
        console.log(`Error getting Blog from frontend: ${error}`);
      }
    };

    fetchData();
  }, []);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.get(
          `${API_BASE_URL}/walk/list2`
        );
        setAbout2(response.data.data);
      } catch (error) {
        console.log(`Error getting Blog from frontend: ${error}`);
      }
    };

    fetchData();
  }, []);
  useEffect(() => {
    const fetchQrcode = async () => {
      try {
        const response = await axios.get(
          `${API_BASE_URL}/qr/list`
        );
        setQr_code(response.data.data);
      } catch (error) {
        console.log(`Error getting Blog from frontend: ${error}`);
      }
    };

    fetchQrcode();
  }, []);
  useEffect(() => {
    const fetchGameQuestions = async () => {
      try {
        const [levelsResponse, questionsResponse] = await Promise.all([
          axios.get(`${API_BASE_URL}/game/levels?all=1`),
          axios.get(`${API_BASE_URL}/game/questions/all`),
        ]);
        const levels = Array.isArray(levelsResponse.data) ? levelsResponse.data : [];
        const questions = Array.isArray(questionsResponse.data) ? questionsResponse.data : [];
        const validLevelNames = new Set(
          levels
            .map((level) => String(level?.name || "").trim())
            .filter(Boolean)
        );
        const filteredQuestions = questions.filter((question) =>
          validLevelNames.has(String(question?.level || "").trim())
        );
        setGameQuestions(filteredQuestions);
      } catch (error) {
        console.log(`Error getting Blog from frontend: ${error}`);
      }
    };

    fetchGameQuestions();
  }, []);

  useEffect(() => {
    const fetchIntroVideos = async () => {
      try {
        const response = await axios.get(
          `${API_BASE_URL}/homevideo/list`
        );
        if (response.data && response.data.success) {
          setIntroVideos(response.data.data || []);
        }
      } catch (error) {
        console.log(`Error getting intro videos: ${error}`);
      }
    };
    fetchIntroVideos();
  }, []);

  useEffect(() => {
    const fetchSocialMedia = async () => {
      try {
        const response = await axios.get(
          `${API_BASE_URL}/qr/socialMedia/list`
        );
        const data = response?.data;
        const list = Array.isArray(data) ? data : Array.isArray(data?.data) ? data.data : [];
        setSocialMediaIcons(list);
      } catch (error) {
        console.log(`Error getting social media: ${error}`);
      }
    };
    fetchSocialMedia();
  }, []);

  useEffect(() => {
    const fetchContacts = async () => {
      try {
        const response = await axios.get(
          `${API_BASE_URL}/contact/list`
        );
        if (response.data && response.data.success) {
          setContacts(response.data.data || []);
        }
      } catch (error) {
        console.log(`Error getting contact: ${error}`);
      }
    };
    fetchContacts();
  }, []);

  useEffect(() => {
    const fetchLocations = async () => {
      try {
        const response = await axios.get(
          `${API_BASE_URL}/location/list`
        );
        if (response.data && response.data.success) {
          setLocationCount((response.data.data || []).length);
        }
      } catch (error) {
        console.log(`Error getting locations: ${error}`);
      }
    };
    fetchLocations();
  }, []);

  useEffect(() => {
    const fetchAnnouncements = async () => {
      try {
        const response = await axios.get(
          `${API_BASE_URL}/announcements/list`
        );
        setAnnouncements(response.data.data || []);
      } catch (error) {
        console.log(`Error getting announcements: ${error}`);
      }
    };
    fetchAnnouncements();
  }, []);

  useEffect(() => {
    const fetchLevels = async () => {
      try {
        const response = await axios.get(
          `${API_BASE_URL}/game/levels?all=1`
        );
        setGameLevels(Array.isArray(response.data) ? response.data : []);
      } catch (error) {
        console.log(`Error getting game levels: ${error}`);
      }
    };
    fetchLevels();
  }, []);

  useEffect(() => {
    const fetchWinners = async () => {
      try {
        const response = await axios.get(
          `${API_BASE_URL}/game/winners`
        );
        setGameWinners(Array.isArray(response.data) ? response.data : []);
      } catch (error) {
        console.log(`Error getting game winners: ${error}`);
      }
    };
    fetchWinners();
  }, []);

  useEffect(() => {
    const fetchGameStats = async () => {
      try {
        const { from, to } = getDefaultGameStatsRange();
        const response = await axios.get(
          `${API_BASE_URL}/game/stats?from=${from}&to=${to}`
        );
        setGameStatsTotals(response.data?.totals || { total_winners: 0, total_participants: 0 });
      } catch (error) {
        console.log(`Error getting game stats: ${error}`);
      }
    };
    fetchGameStats();
  }, []);

  const handleUpdateClick = () => {
    setIsUpdateClicked(true);
  };
  return (
    <>
      <div className="content">
        <Row>
       
          {/* <Col lg="3" md="6" sm="6">
            <Card className="card-stats">
              <CardBody>
                <Row>
                  <Col md="4" xs="5">
                    <div className="icon-big text-center icon-warning">
                      <i className="nc-icon nc-album-2 text-success" />
                    </div>
                  </Col>
                  <Col md="8" xs="7">
                    <div className="numbers">
                      <p className="card-category">Gallery</p>
                      <CardTitle tag="p">{gallerycount.length}</CardTitle>
                      <p />
                    </div>
                  </Col>
                </Row>
              </CardBody>
              <CardFooter>
                <hr />
              </CardFooter>
            </Card>
          </Col> */}
          {/* <Col lg="3" md="6" sm="6"> */}
            {/* <Card className="card-stats"> */}
              {/* <CardBody>
                <Row>
                  <Col md="4" xs="5">
                    <div className="icon-big text-center icon-warning">
                      <i className="nc-icon nc-chat-33 text-success" />
                    </div>
                  </Col>
                  <Col md="8" xs="7">
                    <div className="numbers">
                      <p className="card-category">Social Media</p>
                      <CardTitle tag="p">{SocialMediacount.length}</CardTitle>
                      <p />
                    </div>
                  </Col>
                </Row>
              </CardBody> */}
              {/* <CardFooter>
                <hr />
              </CardFooter>
            </Card>
          </Col> */}
       
          <Col lg="3" md="6" sm="6">
            <Card
              className="card-stats"
              onClick={() => navigate('/admin/Banner')}
              role="button"
              tabIndex={0}
              onKeyDown={(e) => (e.key === 'Enter' || e.key === ' ') && navigate('/admin/Banner')}
              style={cardStyle}
            >
              <CardBody>
                <Row>
                  <Col md="4" xs="5">
                    <div className="icon-big text-center icon-warning">
                      <i className="nc-icon nc-image text-success" />
                    </div>
                  </Col>
                  <Col md="8" xs="7">
                    <div className="numbers">
                      <p className="card-category">Banner</p>
                      <CardTitle tag="p">{bannerCount}</CardTitle>
                      <p />
                    </div>
                  </Col>
                </Row>
              </CardBody>
              <CardFooter>
                <hr />
              </CardFooter>
            </Card>
          </Col>
          <Col lg="3" md="6" sm="6">
            <Card
              className="card-stats"
              onClick={() => navigate('/admin/HomePage')}
              role="button"
              tabIndex={0}
              onKeyDown={(e) => (e.key === 'Enter' || e.key === ' ') && navigate('/admin/HomePage')}
              style={cardStyle}
            >
              <CardBody>
                <Row>
                  <Col md="4" xs="5">
                    <div className="icon-big text-center icon-warning">
                      <i className="nc-icon nc-layout-11 text-warning" />
                    </div>
                  </Col>
                  <Col md="8" xs="7">
                    <div className="numbers">
                      <p className="card-category">Home Page</p>
                      <CardTitle tag="p">{HomePage.length}</CardTitle>
                      <p />
                    </div>
                  </Col>
                </Row>
              </CardBody>
              <CardFooter>
                <hr />
              </CardFooter>
            </Card>
          </Col>
          <Col lg="3" md="6" sm="6">
            <Card
              className="card-stats"
              onClick={() => navigate('/admin/HomeVideo')}
              role="button"
              tabIndex={0}
              onKeyDown={(e) => (e.key === 'Enter' || e.key === ' ') && navigate('/admin/HomeVideo')}
              style={cardStyle}
            >
              <CardBody>
                <Row>
                  <Col md="4" xs="5">
                    <div className="icon-big text-center icon-success">
                      <i className="nc-icon nc-button-play text-success" />
                    </div>
                  </Col>
                  <Col md="8" xs="7">
                    <div className="numbers">
                      <p className="card-category">Intro Video</p>
                      <CardTitle tag="p">{introVideos.length}</CardTitle>
                      <p />
                    </div>
                  </Col>
                </Row>
              </CardBody>
              <CardFooter>
                <hr />
              </CardFooter>
            </Card>
          </Col>
          <Col lg="3" md="6" sm="6">
            <Card
              className="card-stats"
              onClick={() => navigate('/admin/events')}
              role="button"
              tabIndex={0}
              onKeyDown={(e) => (e.key === 'Enter' || e.key === ' ') && navigate('/admin/HomePage')}
              style={cardStyle}
            >
              <CardBody>
                <Row>
                  <Col md="4" xs="5">
                    <div className="icon-big text-center icon-warning">
                      <i className="nc-icon nc-calendar-60 text-warning" />
                    </div>

                  </Col>
                  <Col md="8" xs="7">
                    <div className="numbers">
                      <p className="card-category">Events</p>
                      <CardTitle tag="p">{eventCount.length}</CardTitle>
                      <p />
                    </div>
                  </Col>
                </Row>
              </CardBody>
              <CardFooter>
                <hr />
              </CardFooter>
            </Card>
          </Col>
          <Col lg="3" md="6" sm="6">
            <Card
              className="card-stats"
              onClick={() => navigate('/admin/exposition')}
              role="button"
              tabIndex={0}
              onKeyDown={(e) => (e.key === 'Enter' || e.key === ' ') && navigate('/admin/HomePage')}
              style={cardStyle}
            >
              <CardBody>
                <Row>
                  <Col md="4" xs="5">
                    <div className="icon-big text-center icon-success">
                      <i className="nc-icon nc-album-2 text-success" />
                    </div>
                  </Col>
                  <Col md="8" xs="7">
                    <div className="numbers">
                      <p className="card-category">Exposition</p>
                      <CardTitle tag="p">{gallerycount.length}</CardTitle>
                      <p />
                    </div>
                  </Col>
                </Row>
              </CardBody>
              <CardFooter>
                <hr />
              </CardFooter>
            </Card>
          </Col>
          <Col lg="3" md="6" sm="6">
            <Card
              className="card-stats"
              onClick={() => navigate('/admin/Announcements')}
              role="button"
              tabIndex={0}
              onKeyDown={(e) => (e.key === 'Enter' || e.key === ' ') && navigate('/admin/Announcements')}
              style={cardStyle}
            >
              <CardBody>
                <Row>
                  <Col md="4" xs="5">
                    <div className="icon-big text-center icon-warning">
                      <i className="nc-icon nc-single-copy-04 text-warning" />
                    </div>
                  </Col>
                  <Col md="8" xs="7">
                    <div className="numbers">
                      <p className="card-category">Announcements</p>
                      <CardTitle tag="p">{announcements.length}</CardTitle>
                      <p />
                    </div>
                  </Col>
                </Row>
              </CardBody>
              <CardFooter>
                <hr />
              </CardFooter>
            </Card>
          </Col>
          <Col lg="3" md="6" sm="6">
            <Card
              className="card-stats"
              onClick={() => navigate('/admin/TankShop')}
              role="button"
              tabIndex={0}
              onKeyDown={(e) => (e.key === 'Enter' || e.key === ' ') && navigate('/admin/HomePage')}
              style={cardStyle}
            >
              <CardBody>
                <Row>
                  <Col md="4" xs="5">
                    <div className="icon-big text-center icon-success">
                      <i className="nc-icon nc-delivery-fast text-success" />
                    </div>
                  </Col>
                  <Col md="8" xs="7">
                    <div className="numbers">
                      <p className="card-category">Tank Shop</p>
                      <CardTitle tag="p">{TankShop.length}</CardTitle>
                      <p />
                    </div>
                  </Col>
                </Row>
              </CardBody>
              <CardFooter>
                <hr />
              </CardFooter>
            </Card>
          </Col>
          <Col lg="3" md="6" sm="6">
            <Card
              className="card-stats"
              onClick={() => navigate('/admin/SocialMedia')}
              role="button"
              tabIndex={0}
              onKeyDown={(e) => (e.key === 'Enter' || e.key === ' ') && navigate('/admin/SocialMedia')}
              style={cardStyle}
            >
              <CardBody>
                <Row>
                  <Col md="4" xs="5">
                    <div className="icon-big text-center icon-warning">
                      <i className="nc-icon nc-chat-33 text-warning" />
                    </div>
                  </Col>
                  <Col md="8" xs="7">
                    <div className="numbers">
                      <p className="card-category">Social Media</p>
                      <CardTitle tag="p">{socialMediaIcons.length}</CardTitle>
                      <p />
                    </div>
                  </Col>
                </Row>
              </CardBody>
              <CardFooter>
                <hr />
              </CardFooter>
            </Card>
          </Col>
          <Col lg="3" md="6" sm="6">
            <Card
              className="card-stats"
              onClick={() => navigate('/admin/contact')}
              role="button"
              tabIndex={0}
              onKeyDown={(e) => (e.key === 'Enter' || e.key === ' ') && navigate('/admin/contact')}
              style={cardStyle}
            >
              <CardBody>
                <Row>
                  <Col md="4" xs="5">
                    <div className="icon-big text-center icon-success">
                      <i className="nc-icon nc-mobile text-success" />
                    </div>
                  </Col>
                  <Col md="8" xs="7">
                    <div className="numbers">
                      <p className="card-category">Contact</p>
                      <CardTitle tag="p">{contacts.length + locationCount}</CardTitle>
                      <p />
                    </div>
                  </Col>
                </Row>
              </CardBody>
              <CardFooter>
                <hr />
              </CardFooter>
            </Card>
          </Col>
          <Col lg="3" md="6" sm="6">
            <Card
              className="card-stats"
              onClick={() => navigate('/admin/game-levels')}
              role="button"
              tabIndex={0}
              onKeyDown={(e) => (e.key === 'Enter' || e.key === ' ') && navigate('/admin/game-levels')}
              style={cardStyle}
            >
              <CardBody>
                <Row>
                  <Col md="4" xs="5">
                    <div className="icon-big text-center icon-warning">
                      <i className="nc-icon nc-settings text-warning" />
                    </div>
                  </Col>
                  <Col md="8" xs="7">
                    <div className="numbers">
                      <p className="card-category">Game Levels</p>
                      <CardTitle tag="p">{gameLevels.length}</CardTitle>
                      <p />
                    </div>
                  </Col>
                </Row>
              </CardBody>
              <CardFooter>
                <hr />
              </CardFooter>
            </Card>
          </Col>
          <Col lg="3" md="6" sm="6">
            <Card
              className="card-stats"
              onClick={() => navigate('/admin/questions')}
              role="button"
              tabIndex={0}
              onKeyDown={(e) => (e.key === 'Enter' || e.key === ' ') && navigate('/admin/questions')}
              style={cardStyle}
            >
              <CardBody>
                <Row>
                  <Col md="4" xs="5">
                    <div className="icon-big text-center icon-success">
                      <i className="nc-icon nc-controller-modern text-success" />
                    </div>
                  </Col>
                  <Col md="8" xs="7">
                    <div className="numbers">
                      <p className="card-category">Game Questions</p>
                      <CardTitle tag="p">{gameQuestions.length}</CardTitle>
                      <p />
                    </div>
                  </Col>
                </Row>
              </CardBody>
              <CardFooter>
                <hr />
              </CardFooter>
            </Card>
          </Col>
          <Col lg="3" md="6" sm="6">
            <Card
              className="card-stats"
              onClick={() => navigate('/admin/game-draws-winners')}
              role="button"
              tabIndex={0}
              onKeyDown={(e) => (e.key === 'Enter' || e.key === ' ') && navigate('/admin/game-draws-winners')}
              style={cardStyle}
            >
              <CardBody>
                <Row>
                  <Col md="4" xs="5">
                    <div className="icon-big text-center icon-warning">
                      <i className="nc-icon nc-trophy text-warning" />
                    </div>
                  </Col>
                  <Col md="8" xs="7">
                    <div className="numbers">
                      <p className="card-category">Game Draw & Winners</p>
                      <CardTitle tag="p">{gameDrawsWinnersCount}</CardTitle>
                      <p />
                    </div>
                  </Col>
                </Row>
              </CardBody>
              <CardFooter>
                <hr />
              </CardFooter>
            </Card>
          </Col>
          <Col lg="3" md="6" sm="6">
            <Card
              className="card-stats"
              onClick={() => navigate('/admin/game-stats')}
              role="button"
              tabIndex={0}
              onKeyDown={(e) => (e.key === 'Enter' || e.key === ' ') && navigate('/admin/game-stats')}
              style={cardStyle}
            >
              <CardBody>
                <Row>
                  <Col md="4" xs="5">
                    <div className="icon-big text-center icon-warning">
                      <i className="nc-icon nc-chart-bar-32 text-success" />
                    </div>
                  </Col>
                  <Col md="8" xs="7">
                    <div className="numbers">
                      <p className="card-category">Game Stats</p>
                      {/* <CardTitle tag="p">{gameStatsTotals.total_winners}</CardTitle> */}
                      <CardTitle tag="p"> - </CardTitle>
                      <p />
                    </div>
                  </Col>
                </Row>
              </CardBody>
              <CardFooter>
                <hr />
              </CardFooter>
            </Card>
          </Col>
          <Col lg="3" md="6" sm="6">
            <Card
              className="card-stats"
              onClick={() => navigate('/admin/game-exports')}
              role="button"
              tabIndex={0}
              onKeyDown={(e) => (e.key === 'Enter' || e.key === ' ') && navigate('/admin/game-exports')}
              style={cardStyle}
            >
              <CardBody>
                <Row>
                  <Col md="4" xs="5">
                    <div className="icon-big text-center icon-warning">
                      <i className="nc-icon nc-cloud-download-93 text-warning" />
                    </div>
                  </Col>
                  <Col md="8" xs="7">
                    <div className="numbers">
                      <p className="card-category">Game Exports</p>
                      {/* <CardTitle tag="p">{gameWinners.length}</CardTitle> */}
                      <CardTitle tag="p"> - </CardTitle>
                      <p />
                    </div>
                  </Col>
                </Row>
              </CardBody>
              <CardFooter>
                <hr />
              </CardFooter>
            </Card>
          </Col>
          <Col lg="3" md="6" sm="6">
            <Card
              className="card-stats"
              onClick={() => navigate('/admin/Qr_code')}
              role="button"
              tabIndex={0}
              onKeyDown={(e) => (e.key === 'Enter' || e.key === ' ') && navigate('/admin/HomePage')}
              style={cardStyle}
            >
              <CardBody>
                <Row>
                  <Col md="4" xs="5">
                    <div className="icon-big text-center icon-warning">
                      <i className="nc-icon nc-camera-compact text-success" />
                    </div>
                  </Col>
                  <Col md="8" xs="7">
                    <div className="numbers">
                      <p className="card-category">QR Code</p>
                      <CardTitle tag="p">{qr_code.length}</CardTitle>
                      <p />
                    </div>
                  </Col>
                </Row>
              </CardBody>
              <CardFooter>
                <hr />
              </CardFooter>
            </Card>
          </Col>
          <Col lg="3" md="6" sm="6">
            <Card
              className="card-stats"
              onClick={() => navigate('/admin/WalkThrough')}
              role="button"
              tabIndex={0}
              onKeyDown={(e) => (e.key === 'Enter' || e.key === ' ') && navigate('/admin/HomePage')}
              style={cardStyle}
            >
              <CardBody>
                <Row>
                  <Col md="4" xs="5">
                    <div className="icon-big text-center icon-warning">
                      <i className="nc-icon nc-user-run text-warning" />
                    </div>
                  </Col>
                  <Col md="8" xs="7">
                    <div className="numbers">
                      <p className="card-category">Walk Through</p>
                      <CardTitle tag="p">{About2.length}</CardTitle>
                      <p />
                    </div>
                  </Col>
                </Row>
              </CardBody>
              <CardFooter>
                <hr />
              </CardFooter>
            </Card>
          </Col>
          <Col lg="3" md="6" sm="6">
            <Card
              className="card-stats"
              onClick={() => navigate('/admin/About')}
              role="button"
              tabIndex={0}
              onKeyDown={(e) => (e.key === 'Enter' || e.key === ' ') && navigate('/admin/HomePage')}
              style={cardStyle}
            >
              <CardBody>
                <Row>
                  <Col md="4" xs="5">
                    <div className="icon-big text-center icon-warning">
                      <i className="nc-icon nc-badge text-success" />
                    </div>
                  </Col>
                  <Col md="8" xs="7">
                    <div className="numbers">
                      <p className="card-category">About</p>
                      <CardTitle tag="p">{about.length}</CardTitle>
                      <p />
                    </div>
                  </Col>
                </Row>
              </CardBody>
              <CardFooter>
                <hr />
              </CardFooter>
            </Card>
          </Col>
          <Col lg="3" md="6" sm="6">
            <Card
              className="card-stats"
              onClick={() => navigate('/admin/PrivacyPolicies')}
              role="button"
              tabIndex={0}
              onKeyDown={(e) => (e.key === 'Enter' || e.key === ' ') && navigate('/admin/HomePage')}
              style={cardStyle}
            >
              <CardBody>
                <Row>
                  <Col md="4" xs="5">
                    <div className="icon-big text-center icon-warning">
                      <i className="nc-icon nc-lock-circle-open text-warning" />
                    </div>
                  </Col>
                  <Col md="8" xs="7">
                    <div className="numbers">
                      <p className="card-category">Privacy Policies</p>
                      <CardTitle tag="p">{1}</CardTitle>
                      <p />
                    </div>
                  </Col>
                </Row>
              </CardBody>
              <CardFooter>
                <hr />
              </CardFooter>
            </Card>
          </Col>
          <Col lg="3" md="6" sm="6">
            <Card
              className="card-stats"
              onClick={() => navigate('/admin/Terms')}
              role="button"
              tabIndex={0}
              onKeyDown={(e) => (e.key === 'Enter' || e.key === ' ') && navigate('/admin/HomePage')}
              style={cardStyle}
            >
              <CardBody>
                <Row>
                  <Col md="4" xs="5">
                    <div className="icon-big text-center icon-success">
                      <i className="nc-icon nc-paper text-success" />
                    </div>
                  </Col>
                  <Col md="8" xs="7">
                    <div className="numbers">
                      <p className="card-category">Terms</p>
                      <CardTitle tag="p">{1}</CardTitle>
                      <p />
                    </div>
                  </Col>

                </Row>
              </CardBody>
              <CardFooter>
                <hr />
              </CardFooter>
            </Card>
          </Col>
          <Col lg="3" md="6" sm="6">
            <Card
              className="card-stats"
              onClick={() => navigate('/admin/user-management')}
              role="button"
              tabIndex={0}
              onKeyDown={(e) => (e.key === 'Enter' || e.key === ' ') && navigate('/admin/HomePage')}
              style={cardStyle}
            >
              <CardBody>
                <Row>
                  <Col md="4" xs="5">
                    <div className="icon-big text-center icon-warning">
                      <i className="nc-icon nc-circle-10 text-warning" />
                    </div>
                  </Col>
                  <Col md="8" xs="7">
                    <div className="numbers">
                      <p className="card-category">user Management</p>
                      <CardTitle tag="p">{userCount}</CardTitle>
                      <p />
                    </div>
                  </Col>
                </Row>
              </CardBody>
              <CardFooter>
                <hr />
              </CardFooter>
            </Card>
          </Col>
          <Col lg="3" md="6" sm="6">
            <Card
              className="card-stats"
              onClick={() => navigate('/admin/addUser')}
              role="button"
              tabIndex={0}
              onKeyDown={(e) => (e.key === 'Enter' || e.key === ' ') && navigate('/admin/HomePage')}
              style={cardStyle}
            >
              <CardBody>
                <Row>
                  <Col md="4" xs="5">
                    <div className="icon-big text-center icon-success">
                      <i className="nc-icon nc-single-02 text-success" />
                    </div>
                  </Col>
                  <Col md="8" xs="7">
                    <div className="numbers">
                      <p className="card-category">Admin</p>
                      <CardTitle tag="p">{adminCount.length}</CardTitle>
                      <p />
                    </div>
                  </Col>
                </Row>
              </CardBody>
              <CardFooter>
                <hr />
              </CardFooter>
            </Card>
          </Col>
        </Row>
    
      </div>
    </>
  );
}

export default Dashboard;
